import { Button, Group, Modal, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

interface OverwriteConfirmModalProps {
  opened: boolean
  affectedCount: number
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Mantine modal that confirms a bulk-assess that would overwrite existing
 * student scores. Matches the Figma screenshot ("Overwrite existing
 * assessments?" with student count + Cancel / Yes, overwrite).
 */
export function OverwriteConfirmModal({
  opened,
  affectedCount,
  onConfirm,
  onCancel,
}: OverwriteConfirmModalProps) {
  const { t } = useTranslation()
  const body =
    affectedCount === 1
      ? t('arc_teacher_assessment_drawer.overwrite_modal.body_single')
      : t('arc_teacher_assessment_drawer.overwrite_modal.body_many', {
        count: affectedCount,
      })

  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={t('arc_teacher_assessment_drawer.overwrite_modal.title')}
      size="sm"
      zIndex={400}
      centered
    >
      <Stack spacing="md">
        <Text size="sm">{body}</Text>
        <Group position="right" spacing="sm">
          <Button variant="outline" onClick={onCancel}>
            {t('arc_teacher_assessment_drawer.overwrite_modal.cancel')}
          </Button>
          <Button color="green" onClick={onConfirm}>
            {t('arc_teacher_assessment_drawer.overwrite_modal.confirm')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
